import { useCallback, useState } from 'react';
import { TeamLite } from 'components/organisms/resource-management/types';

interface ReturnProps {
  teamDataForFindMember?: TeamLite;
  closeFindMemberModal: () => void;
  onFindMember: (props: TeamLite) => void;
}

export const useFindMember = (): ReturnProps => {
  const [teamDataForFindMember, setTeamDataForFindMember] =
    useState<TeamLite>();

  const closeFindMemberModal = useCallback(() => {
    setTeamDataForFindMember(undefined);
  }, []);

  const onFindMember = useCallback(
    ({ projectId, teamId, teamName, roleId }: TeamLite) => {
      setTeamDataForFindMember({ projectId, teamId, teamName, roleId });
    },
    [],
  );

  return {
    teamDataForFindMember,
    closeFindMemberModal,
    onFindMember,
  };
};
